<template>
    <v-card   style="min-height:800px">
        <v-card-text>
          <v-layout row wrap>
            <template v-for="(filter,key) in filters">
          <v-flex xs3 md12 sm12>  
                 <DropDown  :selected ="filters.default" v-if="filter.type=='select' || filter.type=='dropdown'" :filters="filter"
                  v-on:change="setFilterId"
                  />
                  
                <TextFilter :selected ="filters.default"  :filters="filter" v-if="filter.type!='select'|| filter.type=='date' " 
                    v-on:change="setFilterId"
                />

        </v-flex>
            </template>
            </v-layout>
        </v-card-text>
    </v-card> 

</template>
<script>
import DropDown from './DropDown.vue'
import TextFilter from './TextFilter.vue'
export default {
    props: [
        "key",
        "filters"
    ],
    components:{
        DropDown,TextFilter
    },

    data () {
      return {
          options: {},
          date: {},
          selectedFilters: [],
          
      }
    },
    methods: {
       
        setFilterId(selected) {
          var $keys = Object.keys(selected);
          //this.selectedFilters[$keys[0]]=selected[$keys[0]] 
          this.filters[$keys[0]].default=selected[$keys[0]]
          console.log(this.filters)
        },

      setFilterIdText(column) {
        console.log(selected)
        console.log(column)
      },
      setColumnId($selected) {
        
        this.selectedColumns.push($selected)
      },
     
    }
}

</script>